<template>
  <a-cascader
    ref="cascaderDom"
    v-model="value"
    class="cascader"
    :options="options"
    :show-search="{ filter }"
    :allow-clear="false"
    :disabled="disabled"
    expand-trigger="hover"
    placeholder="请选择省/市/区"
    :get-popup-container="triggerNode => triggerNode.parentNode"
    @change="onChange"
  />
</template>

<script>
import { getCityAreaTree } from "./api.js";

export default {
  props: {
    defaultProvince: {
      type: Array,
      default: () => [],
    },
    disabled: { 
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      value: [],
      level: 3
    };
  },
  watch: {
    defaultProvince(val) {
      this.value = val;
      this.$nextTick(() => {
        const text = this.$refs.cascaderDom.$el.innerText.split(' / ').join('')
        this.$emit('textSetUp', text)
      })
    },
  },
  async created() {
    const options = await getCityAreaTree({
      filterBlackList: true,
    });
    this.options = this.filterData(options, 1);
  },

  methods: {
    filterData(data, level) {
      data.forEach((e) => {
        e.label = e.areaName;
        e.value = e.areaCode;
        if (level === this.level) {
          e.children = null;
        }
        if (level <= this.level && e.children && e.children.length > 0) {
          this.filterData(e.children, level + 1);
        }
      });
      return data;
    },
    onChange(value,selectedOptions) {
      let provinceText = ''
      selectedOptions.map(item=>{
        provinceText += item.label
        return item
      })
      this.$emit("upDateData", {provinceCode:value,provinceText});
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
  },
};
</script>
<style scoped >
.cascader {
  width: 100%;
}
</style>